const taskDrillDownfilterSortReducer = (
    state = {},
    action: {
      type: "SET_TASKDRILLDOWN_FILTER_SORT";
      payload: any;
    }
  ) => {
    switch (action.type) {
      case "SET_TASKDRILLDOWN_FILTER_SORT":
        return { ...action.payload };
  
      default:
        return state;
    }
  };
  
  export default taskDrillDownfilterSortReducer;